import React, { useCallback, useState, createContext, useEffect } from "react"
import { LocalStorageService } from "../services/LocalStorageService"

export const FavouriteContext = createContext({
  ids: [],
  setIds: (e: string[]) => {},
  addOffer: (e: string) => {},
  deleteOffer: (e: string) => {},
  length: 0
})

const FavouriteProvider = ({ children }) => {
  const [ids, setIds] = useState<string[]>([])

  const deleteOffer = useCallback(
    id => {
      let arr = ids.filter(e => e !== id)
      setIds(arr)
      LocalStorageService.setObject("ids", JSON.stringify(arr))
    },
    [ids],
  )

  const addOffer = useCallback(
    id => {
      let arr = ids
      if (!ids.includes(id)) {
        arr = [...ids, id]
      }
      setIds(arr)
      LocalStorageService.setObject("ids", JSON.stringify(arr))
    },
    [ids],
  )

  const handleSetIds = useCallback(newIds => {
    setIds(newIds)
    LocalStorageService.setObject("ids", JSON.stringify(newIds))
  }, [])

  useEffect(() => {
    const storeIds = LocalStorageService.getObject("ids")
    // @ts-ignore
    const ids = JSON.parse(storeIds) || []
    setIds(ids)
  }, [])

  return (
    <FavouriteContext.Provider
      value={{
        ids: ids,
        setIds: handleSetIds,
        addOffer,
        deleteOffer,
        length: ids.length,
      }}
    >
      {children}
    </FavouriteContext.Provider>
  )
}

export default FavouriteProvider
